import axios from "axios";
import { getAuthToken, setAuthToken } from "../utils/tokenStorage";
import { logout } from "../utils/authActions";
import config from "../config";

const localStorageRefreshToken = localStorage.getItem("refreshToken");

const api = axios.create({
  baseURL: config.API_BASE_URL,
  withCredentials: true,
});

// Create a separate instance for JAVA API
export const javaApi = axios.create({
  baseURL: config.JAVA_API_BASE_URL,
  withCredentials: true,
});

// Attach Access Token Automatically
api.interceptors.request.use((reqConfig) => {
  const token = getAuthToken();
  if (token) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }
  return reqConfig;
});

// Attach Access Token Automatically to Java API
javaApi.interceptors.request.use((reqConfig) => {
  const token = getAuthToken();
  if (token) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }
  return reqConfig;
});

// Auto-Refresh Token if 401 (Unauthorized)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      error.config &&
      !error.config.__isRetry
    ) {
      error.config.__isRetry = true;
      try {
        const { data } = await axios.post(
          `${config.API_BASE_URL}auth/refresh`,
          { localStorageRefreshToken: localStorageRefreshToken },
          { withCredentials: true }
        );
        setAuthToken(data.accessToken);
        error.config.headers.Authorization = `Bearer ${data.accessToken}`;
        return api.request(error.config);
      } catch (refreshError) {
        // logout();
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// Auto-Refresh Token if 401 (Unauthorized) for Java API
javaApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      error.config &&
      !error.config.__isRetry
    ) {
      error.config.__isRetry = true;
      try {
        const { data } = await axios.post(
          `${config.JAVA_API_BASE_URL}auth/refresh`,
          { localStorageRefreshToken: localStorageRefreshToken },
          { withCredentials: true }
        );
        setAuthToken(data.accessToken);
        error.config.headers.Authorization = `Bearer ${data.accessToken}`;
        return javaApi.request(error.config);
      } catch (refreshError) {
        // logout();
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
